import { useConnect } from 'sb-redux-hook'
import { useCallback, useEffect, useMemo } from 'sb-hooks'
import actions from 'redux/actions'


const useTabs = ({ availableTabs = [] }) => {
  const { tab, pathname } = useConnect({
    tab: 'routing.location.query.tab',
    pathname: 'routing.location.pathname',
  })

  const activeTab = useMemo(() => {
    if (availableTabs.includes(tab)) {
      return tab
    }

    return availableTabs.length ? availableTabs[0] : ''
  }, [ tab, availableTabs ])

  const setActiveTab = useCallback((activeTab: string, isReplace = false) => {
    const link = `${pathname}?tab=${activeTab}`

    if (isReplace) {
      actions.models.router.replace(link)
    }
    else {
      actions.models.router.push(link)
    }
  }, [ pathname ])

  useEffect(() => {
    if (tab !== activeTab) {
      setActiveTab(activeTab, true)
    }
  }, [ tab, activeTab ])

  return {
    activeTab,
    setActiveTab,
  }
}


export default useTabs
